import PropTypes from 'prop-types';
// material
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
// components
import OrderItem from './Item';

const RootStyle = styled(List)({
  width: '100%',
  overflow: 'auto',
  paddingTop: '16px'
});

OrderList.propTypes = {
  order: PropTypes.object
};

export default function OrderList({ order }) {
  return (
    <RootStyle>
      {order.bookings.map((booking, i) => (
        <OrderItem key={i} item={booking} />
      ))}
    </RootStyle>
  );
}
